import { gql } from "@apollo/client";

export const GET_PII_TOKEN_INFORMATION = (fields: string) => gql`
  query GetPIITokens($email: String!) {
    getPIITokens(email: $email) {
      id
      email
      ${fields}
      updated_at
      is_deleted
      is_active
      created_at
      userMessage
      isSuccess
      developerMessage
      code
    }
  }
`;

export const SET_PII_TOKEN_INFORMATION = (fields: string) => gql`
  mutation GeneratePIITokens($email: String!) {
    generatePIITokens(email: $email) {
      id
      email
      ${fields}
      is_active
      is_deleted
      created_at
      updated_at
      isSuccess
      code
      developerMessage
      userMessage
    }
  }
`;

export const GET_PII_TOKEN_VALUE = gql`
  query GetPIITokenValue($tokens: [String!]!) {
    getPIITokenValue(tokens: $tokens) {
      isSuccess
      piiTokens {
        token
        value
      }
    }
  }
`;

export const SET_PII_TOKEN_VALUE = (piiTokenVariables, variables) => gql`
mutation CreatePIITokenValue(${variables}) {
  ${
    piiTokenVariables.ss_numToken !== undefined
  ? "ssn: createPIITokenValue(token: $ss_numToken, value: $ss_numValue) { isSuccess token value }"
      : ""
  } 
  ${
    piiTokenVariables.dobToken !== undefined
  ? "dob: createPIITokenValue(token: $dobToken, value: $dobValue) { isSuccess token value }"
      : ""
  }
  ${
    piiTokenVariables.genderToken !== undefined
  ? "gender: createPIITokenValue(token: $genderToken, value: $genderValue) { isSuccess token value }"
      : ""
  }
  ${
    piiTokenVariables.ethnicityToken !== undefined
  ? "ethnicity: createPIITokenValue(token: $ethnicityToken, value: $ethnicityValue) { isSuccess token value }"
      : ""
  }
}
`;

export const UPDATE_PII_TOKEN_VALUE = (piiTokenVariables, variables) => gql`
  mutation UpdatePIITokenValue(${variables}) {
    ${
      piiTokenVariables.ss_numToken !== undefined
  ? "ssn: updatePIITokenValue(token: $ss_numToken, value: $ss_numValue) { isSuccess token value }"
        : ""
    } 
    ${
      piiTokenVariables.dobToken !== undefined
  ? "dob: updatePIITokenValue(token: $dobToken, value: $dobValue) { isSuccess token value }"
        : ""
    }
    ${
      piiTokenVariables.genderToken !== undefined
  ? "gender: updatePIITokenValue(token: $genderToken, value: $genderValue) { isSuccess token value }"
        : ""
    }
    ${
      piiTokenVariables.ethnicityToken !== undefined
  ? "ethnicity: updatePIITokenValue(token: $ethnicityToken, value: $ethnicityValue) { isSuccess token value }"
        : ""
    }
  }
`;

export const getAllReferencesQuery = gql`
  query GetAllReferences($email: String!, $isDeleted: Boolean!) {
    getAllReferences(email: $email, isDeleted: $isDeleted) {
      status
      userMessage
      content {
        companyId
        email
        candidateReference {
          meta {
            lastVisitedPage
            completedSections {
              references
            }
          }
          references {
            id
            dateCompleted
            dateCreated
            dateLastUpdated
            dateNotified
            token
            status
            notificationSent
            facilityName
            startDate
            endDate
            profession
            specialty
            supervisorFirstName
            supervisorLastName
            supervisorTitle
            supervisorEmail
            supervisorPhone
            isDeleted
            referenceId
            atsBullhornCandidateId
            facilityCityState
            employed
          }
        }
      }
    }
  }
`;

export const getReference = gql`
  query GetReference(
    $email: String!
    $getReferenceId: String!
    $companyId: Float!
    $isDeleted: Boolean!
  ) {
    getReference(email: $email, id: $getReferenceId, companyId: $companyId, isDeleted: $isDeleted) {
      status
      userMessage
      content {
        companyId
        email
        candidateReference {
          meta {
            lastVisitedPage
            completedSections {
              references
            }
          }
          references {
            id
            dateCompleted
            dateCreated
            dateLastUpdated
            token
            status
            notificationSent
            facilityName
            startDate
            endDate
            profession
            specialty
            supervisorFirstName
            supervisorLastName
            supervisorTitle
            supervisorEmail
            responseOne
            responseTwo
            responseThree
            comments
            isDeleted
            declinationReason
            supervisorPhone
            dateNotified
            referenceId
            atsBullhornCandidateId
            contactConsent
            facilityCityState
            employed
          }
        }
      }
    }
  }
`;

export const SET_REFERENCES = gql`
  mutation SetReferences($referencesInput: ReferencesRequest!) {
    setReferences(referencesInput: $referencesInput) {
      status
      userMessage
      content {
        id
        companyId
        email
        dateCreated
        dateLastUpdated
        createdBy
        updatedBy
        isActive
        isDeleted
        candidateReference {
          meta {
            lastVisitedPage
            completedSections {
              references
            }
          }
          references {
            id
            dateCompleted
            dateCreated
            dateLastUpdated
            token
            status
            notificationSent
            facilityName
            startDate
            endDate
            profession
            specialty
            supervisorFirstName
            supervisorLastName
            supervisorTitle
            supervisorEmail
            supervisorPhone
            responseOne
            responseTwo
            responseThree
            comments
            isDeleted
            declinationReason
            dateNotified
            referenceId
            atsBullhornCandidateId
            facilityCityState
            employed
          }
        }
      }
    }
  }
`;

export const DELETE_REFERENCES = gql`
  mutation DeleteReferences($referencesInput: ReferencesRequest!) {
    deleteReferences(referencesInput: $referencesInput) {
      status
      userMessage
      content {
        id
        companyId
        email
        dateCreated
        dateLastUpdated
        createdBy
        updatedBy
        isActive
        isDeleted
        candidateReference {
          meta {
            lastVisitedPage
            completedSections {
              references
            }
          }
          references {
            id
            dateCompleted
            dateCreated
            dateLastUpdated
            token
            status
            notificationSent
            facilityName
            startDate
            endDate
            profession
            specialty
            supervisorFirstName
            supervisorLastName
            supervisorTitle
            supervisorEmail
            supervisorPhone
            responseOne
            responseTwo
            responseThree
            comments
            declinationReason
            isDeleted
            referenceId
            atsBullhornCandidateId
            facilityCityState
            employed
          }
        }
      }
    }
  }
`;

export const SET_CANDIDATE = gql`
  mutation setCandidate($registration: CandidateRegistrationInput!) {
    setCandidate(registration: $registration) {
      success
      appRedirectionURL
      developerMessage
      code
      userMessage
    }
  }
`;

export const GET_CHECKLIST = gql`
  query SkillsChecklistDetailsFromAble(
    $email: String!
    $companyId: String!
    $applicantId: String!
    $atsChecklistId: String!
  ) {
    skillsChecklistDetailsFromAble(
      email: $email
      companyId: $companyId
      applicantId: $applicantId
      atsChecklistId: $atsChecklistId
    ) {
      status
      statusCode
      content {
        skillsChecklist {
          id
          customerId
          name
          description
          categoryId
          legend
          subscaleLegend
          scaleStart
          scaleEnd
          required
          useSubSkills
          active
          lastUpdated
          expiration
          created
          draft
          completedDate
          complete
          fileBytes
          fileName
          fileAltId
          signature
          groups {
            id
            checklistId
            name
            initial
            scale
            active
            skills {
              id
              groupId
              name
              scale
              subScaleName
              subScale
              active
              value
            }
          }
        }
      }
      developerMessage
      userMessage
      errorMessage
    }
  }
`;

export const PROFESSION_BY_JOB = gql`
  query ProfessionsByJobType($jobType: String, $category: String) {
    professionsByJobType(jobType: $jobType, category: $category) {
      professions {
        id
        name
        code
        companyId
        category
        company {
          code
        }
      }
    }
  }
`;

export const SPECIALTY_BY_PROFESSION = gql`
  query SpecialtiesByProfession($profession: String, $jobType: String, $category: String) {
    specialtiesByProfession(
      profession: $profession
      jobType: $jobType
      category: $category
      primary: true
    ) {
      specialties {
        professionCode
        companyId
        code
        name
        id
        isPrimary
        company {
          code
        }
      }
    }
  }
`;

export const SEND_EMAIL_VERIFICATION = gql`
  mutation sendCandidateEmailVerification($emailVerification: CandidateEmailVerification!) {
    sendCandidateEmailVerification(emailVerification: $emailVerification) {
      code
      developerMessage
      success
      userMessage
    }
  }
`;

export const getJobQuickApply = gql`
  query getJobQuickApply(
    $jobId: Float!
    $email: String!
    $companyId: Float!
    $bullhornId: String!
    $profession: String!
    $specialty: String!
    $includeSsnAndDob: Boolean
  ) {
    getJobQuickApply(
      jobId: $jobId
      email: $email
      companyId: $companyId
      bullhornId: $bullhornId
      profession: $profession
      specialty: $specialty
      includeSsnAndDob: $includeSsnAndDob
    ) {
      status
      statusCode
      content {
        jobId
        candidateId
        quickApply
        qualifications {
          status
          eligibility
          ssnAndDob {
            quickApply
            socialSecurityNumber
            dateOfBirth
            isSSNAvailable
          }
          specialtyProfession {
            quickApply
            profession
            specialty
            candidateProfession
            candidateSpecialty
          }
          workHistory {
            quickApply
            workHistories {
              profession
              facilityName
              specialty
              endDate
              duration
            }
          }
          credential {
            quickApply
            credentials {
              id
              name
              category
              status
              certified
              type
              step
              compact
            }
          }
          checkList {
            quickApply
            checkLists {
              id
              name
              expirationDate
              status
            }
          }
          reference {
            quickApply
            references {
              id
              status
              specialty
            }
          }
        }
      }
      userMessage
    }
  }
`;

export const GET_MY_TASKS_STATUS = gql`
  query GetMyTaskStatusByApplicantId(
    $applicantId: String!
    $bhCandidateId: Float!
    $companyId: Float!
  ) {
    getMyTaskStatusByApplicantId(
      applicantId: $applicantId
      bhCandidateId: $bhCandidateId
      companyId: $companyId
    ) {
      status
      statusCode
      content {
        meta {
          placement {
            facilityName
            startDate
          }
        }
        forms {
          status
          statusCode
          userMessage
          developerMessage
          errorMessage
          tasks {
            completeCount
            incompleteCount
            complete {
              formId
              name
              isComplete
              link
              workflowId
            }
            incomplete {
              formId
              name
              isComplete
              link
              workflowId
            }
          }
        }
        checklists {
          status
          statusCode
          userMessage
          developerMessage
          errorMessage
          tasks {
            completeCount
            incompleteCount
            complete {
              checklistId
              atsChecklistId
              name
              isComplete
            }
            incomplete {
              checklistId
              atsChecklistId
              name
              isComplete
            }
          }
        }
        uploads {
          status
          statusCode
          userMessage
          developerMessage
          errorMessage
          tasks {
            completeCount
            incompleteCount
            complete {
              id
              name
              isComplete
              status
              certificationFileAttachments {
                id
              }
            }
            incomplete {
              id
              status
              name
              isComplete
              dateExpiration
              dateCompleted
              licenseNumber
              certificationFileAttachments {
                id
                name
                fileSize
                contentType
                isEncrypted
                contentSubType
                dateAdded
                dateLastModified
                directory
                fileExtension
                fileOwner {
                  id
                  firstName
                  lastName
                }
                isExternal
                migrateGUID
                type
              }
            }
          }
        }
      }
      userMessage
      developerMessage
      errorMessage
    }
  }
`;

export const RESEND_EMAIL = gql`
  mutation resendEmailVerification($emailVerification: CandidateEmailVerification!) {
    resendEmailVerification(emailVerification: $emailVerification) {
      code
      developerMessage
      success
      userMessage
    }
  }
`;

export const getCandidateCredentials = gql`
  query GetCandidateCredentials(
    $bhCandidateId: Float!
    $companyId: Float!
    $certificationList: Boolean
  ) {
    getCandidateCredentials(
      bhCandidateId: $bhCandidateId
      companyId: $companyId
      certificationList: $certificationList
    ) {
      status
      statusCode
      userMessage
      developerMessage
      certificationList {
        id
        name
        status
        dateExpiration
        dateCompleted
        licenseNumber
        certificationFileAttachments {
          id
        }
      }
    }
  }
`;

/**
 * Gets Candidate Credential File data,
 * Required Variable { "credentialsFileId": number! }
 */
export const getCredentialsFile = gql`
  query GetCredentialsFile($credentialsFileId: Float!) {
    getCredentialsFile(credentialsFileId: $credentialsFileId) {
      isSuccess
      code
      developerMessage
      userMessage
      file {
        name
        contentType
        fileContent
      }
    }
  }
`;

export const UpdateCandidateCredentials = gql`
  mutation UpdateCandidateCredentials(
    $bhCandidateId: Float
    $candidateCertId: Float!
    $companyId: Float!
    $certificationContent: CertificationContentUpdate
    $certificationFileIds: [Float!]
    $certificationFiles: [CertificationFile!]
  ) {
    updateCandidateCredentials(
      bhCandidateId: $bhCandidateId
      candidateCertId: $candidateCertId
      companyId: $companyId
      certificationContent: $certificationContent
      certificationFileIds: $certificationFileIds
      certificationFiles: $certificationFiles
    ) {
      status
      statusCode
      userMessage
      developerMessage
    }
  }
`;

export const SaveCandidateCredentials = gql`
  mutation SaveCandidateCredentials(
    $bhCandidateId: Float
    $companyId: Float!
    $certificationContent: CertificationContent
    $certificationFiles: [CertificationFile!]
  ) {
    saveCandidateCredentials(
      bhCandidateId: $bhCandidateId
      companyId: $companyId
      certificationContent: $certificationContent
      certificationFiles: $certificationFiles
    ) {
      status
      statusCode
      developerMessage
      userMessage
    }
  }
`;

export const GET_COMPLETED_FORM_FILE = gql`
  query GetCompletedFormFile(
    $email: String!
    $companyId: String!
    $applicantId: String!
    $workflowId: String!
    $signRequestId: String!
  ) {
    getCompletedFormFile(
      email: $email
      companyId: $companyId
      applicantId: $applicantId
      workflowId: $workflowId
      signRequestId: $signRequestId
    ) {
      developerMessage
      status
      statusCode
      userMessage
      file {
        contentType
        fileContent
        name
      }
    }
  }
`;

export const GET_COMPLETED_SKILL_CHECKLIST_FILE = gql`
  query GetCompletedSkillchecklistFile(
    $email: String!
    $companyId: String!
    $applicantId: String!
    $applicantChecklistId: String!
  ) {
    getCompletedSkillchecklistFile(
      email: $email
      companyId: $companyId
      applicantId: $applicantId
      applicantChecklistId: $applicantChecklistId
    ) {
      developerMessage
      status
      statusCode
      userMessage
      file {
        contentType
        fileContent
        name
      }
    }
  }
`;

export const getAllPaystubs = gql`
  query GetAllPaystubs($candidateId: String!) {
    getAllPaystubs(candidateId: $candidateId) {
      status
      content {
        id
        candidateId
        payPeriod
        checkDate
        taxableGross
        totalNetPay
        title
        name
        payMethod
        totalHours
        totalPay
        totalTaxAmount
      }
      userMessage
    }
  }
`;

export const getPaystub = gql`
  query GetPaystub($paystubId: String!, $candidateId: String!) {
    getPaystub(id: $paystubId, candidateId: $candidateId) {
      status
      content {
        id
        candidateId
        payPeriod
        checkDate
        taxableGross
        totalNetPay
        title
        name
        payMethod
        totalHours
        totalPay
        totalTaxAmount
        totalDeductionAmount
        totalReimbursementAmount
        earnings {
          id
          paystubId
          client
          date
          type
          hours
          rate
          amount
        }
        deductions {
          id
          paystubId
          description
          deduction
          amount
        }
        reimbursements {
          id
          paystubId
          description
          deduction
          amount
        }
        pto {
          id
          paystubId
          description
          avail
          ytdUsed
        }
        taxes {
          id
          paystubId
          tax
          amount
        }
      }
      userMessage
    }
  }
`;

export const GET_MY_JOBS = gql`
  query MyJobs($actionFilters: String!, $companyId: Int!, $bhCandidateId: Int!) {
    myJobs(actionFilters: $actionFilters, companyId: $companyId, bhCandidateId: $bhCandidateId) {
      embedded {
        aggregations {
          min_salary
          max_salary
        }
        resultOfType
        results {
          id
          atsId
          atsJobId
          webJobId
          title
          jobStatus
          description
          category
          keywords
          city
          state
          zip
          country
          location
          companyId
          companyName
          facilityId
          facilityName
          numberOfBeds
          numberOfOpen
          numberOfFilled
          latitude
          longitude
          tags
          shift
          professions
          professionCode
          professionDescription
          specialties
          specialtyCode
          specialtyDescription
          submissionDate
          msp
          type
          salaryMin
          salaryMax
          duration
          salaryHourly
          salaryExpenseReimbursementWeekly
          isIvs
          isApplied
          isEmailed
          isFavorite
          isQuickApplied
          hoursPerWeek
          priority
          w2Owner
          metro
          imageUri
          subcontractor
          startDate
          datePosted
          replyToEmail
          schedule
        }
        tags {
          name
          count
        }
      }
      isSuccess
      code
      developerMessage
      userMessage
    }
  }
`;

export const GET_ALL_WORK_EXPERIENCE = gql`
  query GetAllWorkExperience($email: String!, $isDeleted: Boolean) {
    getAllWorkExperience(email: $email, isDeleted: $isDeleted) {
      status
      userMessage
      content {
        candidateWorkExperience {
          meta {
            lastVisitedPage
            completedSections {
              basicInfo
              references
              skillsChecklists
              specialtiesAndEducation
              workExperience
            }
          }
          workExperience {
            atsBullhornCandidateId
            chargeExperience
            city
            emrTechnology
            endDate
            facilityName
            facilityType
            floatingPlace
            isCurrentlyWorking
            isTempJob
            isVerified
            meta {
              associations {
                isDeleted
                tenantEntityId
                tenantId
                tenantLastEgressSyncDate
                tenantLastIngressSyncDate
              }
              createdBy
              createdDate
              id
              updatedBy
              updatedDate
            }
            patientRatio
            position
            profession
            reasonForLeaving
            shiftWorked
            specialty
            staffingAgency
            startDate
            supervisor
            teachingFacility
          }
        }
        companyId
        createdBy
        dateCreated
        dateLastUpdated
        email
        id
        isActive
        isDeleted
        updatedBy
      }
    }
  }
`;

export const SET_WORK_EXPERIENCE = gql`
  mutation SetWorkExperience($workExperienceInput: WorkExperienceRequest!) {
    setWorkExperience(workExperienceInput: $workExperienceInput) {
      status
      content {
        id
        companyId
        email
        dateCreated
        dateLastUpdated
        createdBy
        updatedBy
        isActive
        isDeleted
        candidateWorkExperience {
          workExperience {
            meta {
              id
              createdDate
              createdBy
              updatedDate
              updatedBy
              associations {
                tenantId
                tenantEntityId
                tenantLastIngressSyncDate
                tenantLastEgressSyncDate
                isDeleted
              }
            }
            facilityName
            city
            profession
            specialty
            position
            supervisor
            shiftWorked
            facilityType
            emrTechnology
            patientRatio
            floatingPlace
            teachingFacility
            chargeExperience
            startDate
            endDate
            isCurrentlyWorking
            reasonForLeaving
            staffingAgency
            isTempJob
            isVerified
            atsBullhornCandidateId
          }
          meta {
            lastVisitedPage
            completedSections {
              workExperience
            }
          }
        }
      }
      userMessage
    }
  }
`;

export const UPDATE_WORK_EXP_STATUS = gql`
  mutation UpdateWorkExperienceStatus(
    $updateWorkExperienceStatusInput: UpdateWorkExperienceStatusRequest!
  ) {
    updateWorkExperienceStatus(updateWorkExperienceStatusInput: $updateWorkExperienceStatusInput) {
      status
      content {
        id
        companyId
        email
        dateCreated
        dateLastUpdated
        createdBy
        updatedBy
        isActive
        isDeleted
        candidateWorkExperience {
          meta {
            lastVisitedPage
            completedSections {
              workExperience
            }
          }
          workExperience {
            meta {
              id
              createdDate
              createdBy
              updatedBy
              updatedDate
              associations {
                tenantId
                tenantEntityId
                tenantLastIngressSyncDate
                tenantLastEgressSyncDate
                isDeleted
              }
            }
            facilityName
            city
            profession
            specialty
            position
            supervisor
            shiftWorked
            facilityType
            emrTechnology
            patientRatio
            floatingPlace
            teachingFacility
            chargeExperience
            startDate
            endDate
            isCurrentlyWorking
            reasonForLeaving
            staffingAgency
            isTempJob
            isVerified
            atsBullhornCandidateId
          }
        }
      }
      userMessage
    }
  }
`;

export const GET_BH_CANDIDATE_EXTERNAL_ID = gql`
  query GetBHCandidateExternalId($email: String!) {
    getBHCandidateExternalId(email: $email) {
      isSuccess
      code
      developerMessage
      userMessage
      bhCandidateId
    }
  }
`;

export const GET_WEATHER_DATA = gql`
  query getWeather($zip: String!) {
    getAvgHighTemperature(zipCode: $zip) {
      city
      state
      zipCode
      Jan21
      Feb21
      Mar21
      Apr21
      May21
      Jun21
      Jul21
      Aug21
      Sep21
      Oct21
      Nov21
      Dec21
    }
    getAvgLowTemperature(zipCode: $zip) {
      city
      state
      zipCode
      Jan21
      Feb21
      Mar21
      Apr21
      May21
      Jun21
      Jul21
      Aug21
      Sep21
      Oct21
      Nov21
      Dec21
    }
    getAvgRainfall(zipCode: $zip) {
      city
      state
      zipCode
      Jan21
      Feb21
      Mar21
      Apr21
      May21
      Jun21
      Jul21
      Aug21
      Sep21
      Oct21
      Nov21
      Dec21
    }
  }
`;

export const GET_PII_TOKENS = gql`
query GetPIITokens($email: String!) {
  getPIITokens(email: $email) {
    id
    email
    dob
    gender
    ethnicity
    ss_num
    updated_at
    is_deleted
    is_active
    created_at
    userMessage
    isSuccess
    developerMessage
    code
  }
}
`;

export const GET_SKILL_CHECKLIST =gql `
query Query {
  getSkillschecklists {
    isSuccess
    code
    developerMessage
    userMessage
    skillschecklists {
      id
      name
    }
  }
}`;


export const GET_MY_JOBS_STATUS = gql`
query MyJobs($actionFilters: String!, $companyId: Int!, $bhCandidateId: Int) {
  myJobs(actionFilters: $actionFilters, companyId: $companyId, bhCandidateId: $bhCandidateId) {
    embedded {
      results {
        jobStatus
      }
    }
  }
}
`;
